import { render, staticRenderFns } from "./TeamPerson.vue?vue&type=template&id=812fac50"
import script from "./TeamPerson.vue?vue&type=script&lang=js"
export * from "./TeamPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports